import { useMemo } from "react";
import { type SelectInputProps, SelectInput, useGetList } from "react-admin";

import { MODULE_NAMES } from "@/constants/modules";

export const TrafficSourceInput = (
  props: Pick<SelectInputProps, "source" | "validate" | "alwaysOn">,
) => {
  const { isPending, data = [] } = useGetList<{
    id: string;
  }>(MODULE_NAMES.TRAFFIC_SOURCES);

  const choices = useMemo(
    () =>
      data.map((item) => ({
        ...item,
        ["@id"]: `/api/vpn/traffic_sources/${item.id}`,
      })),
    [data],
  );

  return (
    <SelectInput
      source={props.source}
      validate={props.validate}
      isPending={isPending}
      optionValue="@id"
      optionText="title"
      choices={choices}
    />
  );
};
